import request from '@/utils/request'

const api = {
  assessList: '/assess/assess/list'
}

export function assessList (parameter) {
  return request({
    url: api.assessList,
    method: 'get',
    params: parameter
  })
}
